/**
 * LayoutRistorazione — Layout minimal per il deploy variant "ristorazione".
 *
 * Operatori/Admin: niente sidebar laterale, niente header globale,
 *  solo bottom nav 3 voci sempre visibile (Home/Documenti/Impostazioni).
 *
 * SA/Consulente (R52.17): nessuna bottom nav, sidebar fissa 256px su PC
 *  (drawer + FAB su mobile). Il content viene shiftato a destra di pl-64
 *  solo per questi ruoli.
 *
 * R60.13: DemoExpiredModal bloccante quando la demo è scaduta (admin/operator).
 *
 * Iter R52.1 + R52.17 + R60.13.
 */
import { Outlet } from "react-router-dom";
import BottomNavRistorazione from "@/components/BottomNavRistorazione";
import SaDrawer from "@/components/SaDrawer";
import SaMobileBottomNav from "@/components/SaMobileBottomNav";
import LaunchBanner from "@/components/LaunchBanner";
import DemoExpiredModal from "@/components/DemoExpiredModal";
import DemoCountdownBumper from "@/components/DemoCountdownBumper";
import FirstSetupWizard from "@/components/FirstSetupWizard";
import { SaFloatingExitButton } from "@/components/layout/LayoutSaScope";
import { useAuth } from "@/context/AuthContext";

function isDemoExpired(user) {
  if (!user?.is_demo || !user?.demo_expires_at) return { expired: false, days: 0 };
  const exp = new Date(user.demo_expires_at + "T23:59:59");
  const now = new Date();
  if (isNaN(exp.getTime())) return { expired: false, days: 0 };
  const diffMs = now.getTime() - exp.getTime();
  const daysOverdue = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return { expired: diffMs > 0, days: Math.max(0, daysOverdue) };
}

export default function LayoutRistorazione() {
  const { user } = useAuth();
  const isDirectional = user?.role === "superadmin" || user?.role === "consultant";
  const isManualeOnly = !!user?.is_manuale_only;
  const { expired, days } = isDemoExpired(user);
  const showDemoBlock = expired && !isDirectional && !isManualeOnly && (user?.role === "admin" || user?.role === "operator");

  return (
    <div className="min-h-screen bg-slate-100" data-testid="layout-ristorazione">
      {!isManualeOnly && <LaunchBanner />}
      {!showDemoBlock && !isManualeOnly && <DemoCountdownBumper />}
      <SaFloatingExitButton />
      <div className={isDirectional ? "lg:pl-64" : undefined}>
        <Outlet />
      </div>
      {!isManualeOnly && <BottomNavRistorazione />}
      <SaDrawer />
      <SaMobileBottomNav />
      {showDemoBlock && <DemoExpiredModal user={user} daysOverdue={days} />}
      {/* R60.13 — Setup obbligatorio al primo login admin post-demo/attivazione.
          Non si mostra se la demo è scaduta (priorità al modal blocca), per SA,
          né per utenti manuale-only (R60.30). */}
      {!showDemoBlock && !isDirectional && !isManualeOnly && user?.role === "admin" && <FirstSetupWizard />}
    </div>
  );
}
